module.exports = __webpack_public_path__ + "img/favorite.2263e656.svg";